import { ActionStatus } from '../../../../common/constants/action-status';
import { StoreState } from '../../../../store/store.interface';

export const getGooglePayInstanceStatus = (state: StoreState) => state.braintreeState.googlePayInstance.status;

export const getGooglePaymentClientStatus = (state: StoreState) => state.braintreeState.googlePaymentClient.status;

export const getGooglePayInstance = (state: StoreState) => state.braintreeState.googlePayInstance.data;

export const getGooglePaymentClient = (state: StoreState) => state.braintreeState.googlePaymentClient.data;

export const isGooglePayEnabled = (state: StoreState) => !!state.shopCheckoutState.clientToken.data?.googlePayEnabled;

export const isGooglePayReadyUse = (state: StoreState) =>
  state.braintreeState.googlePayInstance.status === ActionStatus.succeeded &&
  state.braintreeState.googlePaymentClient.status === ActionStatus.succeeded;
